// extracted by mini-css-extract-plugin
module.exports = {"bottom-shape":"styles_bottom-shape__jQneA"};